import qs from 'query-string';
import { matchPath } from 'react-router-dom';

/**
 * Builds a path for routes and navigation
 * If the provided path does not include a firmKey, it will prepend the firmKey from the current window location if it exists.
 * If the provided path already includes a firmKey, it will return the path as is.
 * If the provided path does not match the expected format, it throws an error.
 */
export function preserveFirmKey(path: string) {
  const pathMatch = matchPath('/:firmKey?/app/*', path);

  if (!pathMatch) {
    throw new Error('Path must start with /app or /:firmKey/app');
  }

  if (!pathMatch.params.firmKey) {
    const windowLocationMatch = matchPath('/:firmKey?/app/*', window.location.pathname);
    const firmKey = windowLocationMatch?.params.firmKey;

    if (firmKey) return `/${firmKey}${path}`;
  }

  return path;
}

export function navigateOut(path: string) {
  window.open(path, '_blank');
}

export function locationAssign(path: string) {
  window.location.assign(path);
}

export function locationReplace(path: string) {
  window.location.replace(path);
}

export function addUrlParams(url: string, extraParams: { [key: string]: string | undefined }): string {
  const { url: baseUrl, query } = qs.parseUrl(url);

  return qs.stringifyUrl({ url: baseUrl, query: { ...query, ...extraParams } });
}
